import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { Provider } from 'react-redux';
import { SiteSettingsProvider } from './components/SiteSettings';

import store from './store';



const container = document.getElementById('root');
const root = createRoot(container!);
const app = (
  <BrowserRouter>
    <Provider store={store}>
      <SiteSettingsProvider>
        <App />
      </SiteSettingsProvider>
    </Provider>
  </BrowserRouter>
);
root.render(app);
